/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IntranetPortal_GitLabTicketGenerator_Dtos_GetGitLabIssueDto } from '../models/IntranetPortal_GitLabTicketGenerator_Dtos_GetGitLabIssueDto';
import type { IntranetPortal_GitLabTicketGenerator_Dtos_PostGitLabTicketInputDto } from '../models/IntranetPortal_GitLabTicketGenerator_Dtos_PostGitLabTicketInputDto';
import type { IntranetPortal_GitLabTicketGenerator_Dtos_PostGitLabTicketResultDto } from '../models/IntranetPortal_GitLabTicketGenerator_Dtos_PostGitLabTicketResultDto';
import type { IntranetPortal_GitLabTicketGenerator_Dtos_ProjectDto } from '../models/IntranetPortal_GitLabTicketGenerator_Dtos_ProjectDto';
import type { IntranetPortal_GitLabTicketGenerator_Dtos_TicketTypeDto } from '../models/IntranetPortal_GitLabTicketGenerator_Dtos_TicketTypeDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GitLabTicketGeneratorService {

    /**
     * @param searchName
     * @returns IntranetPortal_GitLabTicketGenerator_Dtos_ProjectDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppGitLabTicketGeneratorUserProjects(
        searchName?: string,
    ): CancelablePromise<Array<IntranetPortal_GitLabTicketGenerator_Dtos_ProjectDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/git-lab-ticket-generator/user-projects',
            query: {
                'searchName': searchName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @returns IntranetPortal_GitLabTicketGenerator_Dtos_TicketTypeDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppGitLabTicketGeneratorTicketTypes(): CancelablePromise<Array<IntranetPortal_GitLabTicketGenerator_Dtos_TicketTypeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/git-lab-ticket-generator/ticket-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns IntranetPortal_GitLabTicketGenerator_Dtos_PostGitLabTicketResultDto Success
     * @throws ApiError
     */
    public static postCoreApiApiAppGitLabTicketGeneratorGitLabTicket(
        requestBody?: IntranetPortal_GitLabTicketGenerator_Dtos_PostGitLabTicketInputDto,
    ): CancelablePromise<IntranetPortal_GitLabTicketGenerator_Dtos_PostGitLabTicketResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/core-api/api/app/git-lab-ticket-generator/git-lab-ticket',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @param projectId
     * @param searchName
     * @returns IntranetPortal_GitLabTicketGenerator_Dtos_GetGitLabIssueDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppGitLabTicketGeneratorUserStoriesInProject(
        projectId: number,
        searchName?: string,
    ): CancelablePromise<Array<IntranetPortal_GitLabTicketGenerator_Dtos_GetGitLabIssueDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/git-lab-ticket-generator/user-stories-in-project/{projectId}',
            path: {
                'projectId': projectId,
            },
            query: {
                'searchName': searchName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

}
